import React, { Component } from 'react';
import { reportStore } from 'stores/ReportStore';
import { criteriaStore } from 'stores/CriteriaStore';
import { reportActions } from 'actions/ReportActions';
import { HeaderRow, ItemRow, SiteInfoRow } from 'components/Modals/SummaryParts';
import { Subscript } from 'utils/Subscript';
import { standardsConversionFeetMeters, romanize } from 'utils/Utilities';
import standardsConfig from 'js/standards.config';

export default class SummaryModal extends Component {
  constructor(props) {
    super(props);
    const { loads, ...criteriaStoreState } = criteriaStore.getState(); // Ignore loads from criteriaStore
    this.state = {
      ...reportStore.getState(),
      ...criteriaStoreState,
    };
    reportStore.listen(this.storeUpdated.bind(this));
    criteriaStore.listen(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    const { loads, ...criteriaStoreState } = criteriaStore.getState(); // Ignore loads from criteriaStore
    this.setState({
      ...reportStore.getState(),
      ...criteriaStoreState,
    });
  }

  closeSummary() {
    reportActions.closeSummary();
  }

  renderTableItems() {
    const { loads, standardsVersion } = this.state;
    const items = [];

    loads.forEach((load) => {
      if (!load.showInReport) {
        return;
      }
      const { label, checked, details } = load;
      const id = Math.floor(Math.random() * 10000000000 + 2);
      // details for each load
      let loadDetails = [];
      // only handle checked loads
      if (checked) {
        if (label === 'Tsunami') {
          items.push(<HeaderRow label={label} key={`item_row_${id}`} />);
          if (Array.isArray(details)) {
            const [detail] = details;
            loadDetails.push(detail);
          }
        } else {
          let headerLabel = label;
          if (
            label === 'Seismic' &&
            (standardsVersion === '7-22' || standardsVersion === '41-17' || standardsVersion === '41-23')
          ) {
            headerLabel = 'Seismic Data';
          }
          items.push(<HeaderRow label={headerLabel} key={`item_row_${id}`} />);
          if (typeof details !== 'undefined') {
            details.forEach((detail, index) => {
              if (label === 'Tornado') {
                if (
                  detail.value === 'Not in Tornado-Prone Region' ||
                  (detail.value && detail.value.includes('Not Applicable to Risk Category'))
                ) {
                  items.push(
                    <tr>
                      <td colSpan={2}>{detail.value}</td>
                    </tr>
                  );
                } else {
                  if (index === 0) {
                    items.push(
                      <tr>
                        <td colSpan={2}>
                          See Details for V<sub>T</sub>
                        </td>
                      </tr>
                    ); // Ensure only 1 of these gets rendererd
                  }
                }
              } else if (label === 'Seismic' && detail.hasOwnProperty('items')) {
                const items = detail.items.map((item) => {
                  let subscript = new Subscript(item.label);
                  let subscript_component = subscript.output();
                  return {
                    label: subscript_component,
                    value: item.value,
                  };
                });

                // title property is used to add titles between loadDetails
                if (detail.label) {
                  loadDetails.push({
                    title: detail.label,
                  });
                }

                loadDetails = loadDetails.concat(items);
              } else if (
                label === 'Wind' &&
                detail.hasOwnProperty('note') &&
                detail.note.includes('Special Wind Region')
              ) {
                loadDetails.push(detail);
              } else if (typeof detail.note === 'undefined') {
                if (detail.hasOwnProperty('items')) {
                  loadDetails = loadDetails.concat(detail.items);
                } else if (detail.hasOwnProperty('value') && detail.value) {
                  loadDetails.push(detail);
                }
              }
            });
          }
        }

        loadDetails.forEach((detail) => {
          const randomId = Math.floor(Math.random() * 10000000000 + 2);
          // Add titles between loadDetails
          if (detail.title) {
            items.push(<HeaderRow label={detail.title} key={randomId} />);
          } else {
            items.push(<ItemRow details={detail} key={randomId} />);
          }
        });
      }
    });
    return items;
  }

  render() {
    const {
      showSummary,
      standardsVersion,
      soilClass,
      elevationReferenceDatum,
      measurement,
      streetAddress,
      cityState,
      postal,
      latitude,
      longitude,
      riskLevel,
    } = this.state;

    let elevation =
      this.state.elevation === 0 || this.state.elevation
        ? parseInt(standardsConversionFeetMeters(this.state.elevation, 'imperial', this.state.measurement))
        : null;
    let elevationLabel;
    let addressLabel;
    let standardLabel = 'ASCE/SEI ' + standardsVersion;
    let soilText = standardsConfig[standardsVersion].soilClassText[soilClass];

    if (this.state.elevation === 0 || (this.state.elevation && elevation > -1000000 && elevationReferenceDatum)) {
      elevationLabel = elevation + ' ' + (measurement === 'si' ? 'm' : 'ft') + ' (NAVD 88)';
    } else {
      elevationLabel = (
        <span>
          Elevation service not available. Please contact USGS for accurate elevation in this area{' '}
          <a href='https://nationalmap.gov/elevation.html' target='_blank'>
            here.
          </a>
        </span>
      );
    }

    if (!streetAddress) {
      addressLabel = '';
    } else {
      addressLabel = streetAddress + ', ' + cityState + ', ' + postal;
    }

    return (
      <div className={`details-popup-wrapper ${showSummary ? '' : 'hidden'}`}>
        <div id='summaryPopup' className='details-popup'>
          <div className='popup-header blue darken-3 welcome-header'>
            <span>Report Summary</span>
            <span className='details-popup-close-icon' onClick={this.closeSummary.bind(this)} />
          </div>
          <div className='popup-body padding welcome-body'>
            <table className='summary-table'>
              {(standardsVersion === '7-22' || standardsVersion === '41-17' || standardsVersion === '41-23') && (
                <thead>
                  <HeaderRow label='Site Information' key={`item_row_${1}`} />
                  {addressLabel !== '' && <SiteInfoRow label='Address' value={addressLabel} />}
                  <SiteInfoRow label='Elevation' value={elevationLabel} />
                  <SiteInfoRow label='Lat' value={latitude} />
                  <SiteInfoRow label='Long' value={longitude} />
                  <SiteInfoRow label='Standard' value={standardLabel} />
                  <SiteInfoRow label='Risk Category' value={romanize(riskLevel)} />
                  <SiteInfoRow label='Soil Class' value={soilText} />
                </thead>
              )}
              <tbody>{this.renderTableItems()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
